import { authFetch, API_BASE_URL, getHeaders } from './authFetch';

export interface SystemPrompt {
  id: string;
  name: string;
  content: string;
  created_at: string;
  updated_at: string;
}

export interface SystemPromptInput {
  name: string;
  content: string;
}

const systemPromptsUrl = () => `${API_BASE_URL}/api/v1/users/me/system-prompts`;

async function checkResponse(response: Response): Promise<void> {
  if (response.ok) return;
  const body = await response.json().catch(() => null);
  throw new Error(
    typeof body?.detail === 'string'
      ? body.detail
      : `시스템 프롬프트 요청을 처리하지 못했습니다. (${response.status})`,
  );
}

export async function listSystemPrompts(): Promise<{ prompts: SystemPrompt[] }> {
  const response = await authFetch(systemPromptsUrl(), { headers: getHeaders() });
  await checkResponse(response);
  return response.json();
}

export async function createSystemPrompt(input: SystemPromptInput): Promise<SystemPrompt> {
  const response = await authFetch(systemPromptsUrl(), {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(input),
  });
  await checkResponse(response);
  return response.json();
}

export async function updateSystemPrompt(id: string, input: SystemPromptInput): Promise<SystemPrompt> {
  const response = await authFetch(`${systemPromptsUrl()}/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify(input),
  });
  await checkResponse(response);
  return response.json();
}

export async function deleteSystemPrompt(id: string): Promise<void> {
  const response = await authFetch(`${systemPromptsUrl()}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: getHeaders(),
  });
  await checkResponse(response);
}
